import { SILENT, COPY2PAYLOAD, createAction } from 'uix/actions';
// fetch details/columns for nodes given as [{otid, datatype}, ...]
export const getTreeRecords = createAction('GET_TREE_RECORDS', (nodes, fields, batchId = null)=>({
        nodes,
        fields,
        batchId
    }));
// store /api/treeFields result for each otid
export const setTreeRecords = createAction('SET_TREE_RECORDS', (data, links, fields)=>({
        data,
        links,
        fields
    }));
// fetch via /api/treeList?{...params}
export const fetchTreeList = createAction('FETCH_TREE_LIST', (listid, params, paramsKey)=>({
        listid,
        params,
        paramsKey
    }));
// store /api/list result for listid
export const setTreeList = createAction('SET_TREE_LIST', (listid, data, paramsKey)=>({
        listid,
        data,
        paramsKey
    }));
// store db.list_loading[listid] = {params: paramsKey}
export const setTreeListLoading = createAction('SET_TREE_LIST_LOADING', (listid, paramsKey)=>({
        listid,
        paramsKey
    }));
// store db.list_loading[listid] = {error}
export const setTreeListError = createAction('SET_TREE_LIST_ERROR', (listid, error)=>({
        listid,
        error
    }));
// we have serialized getTreeRecords and fetchTreeList - track their activity
export const DBLoadActivity = createAction('DB_LOAD_ACTIVITY', COPY2PAYLOAD, SILENT);
// emit progress info during batched field loading
export const progressTreeRecords = createAction('PROGRESS_TREE_RECORDS', COPY2PAYLOAD);
export const setTrackedRecordsFields = createAction('SET_TRACKED_RECORDS_FIELDS', COPY2PAYLOAD, SILENT);
export const setTrackedSkips = createAction('SET_TRACKED_SKIPS', (trackedSkips)=>({
        trackedSkips
    }));
export const setTreeFieldSchema = createAction('SET_TREE_FIELD_SCHEMA', (schema)=>({
        schema
    }));
export const copyIdsToClipboard = createAction('COPY_IDS_TO_CLIPBOARD', ({ otids })=>({
        otids
    }));
export const storeIdsForClipboard = createAction('STORE_IDS_FOR_CLIPBOARD', ({ otids, request })=>({
        otids,
        request
    }));
